<button (click)="throwTestError()">Test Sentry Error</button>

<router-outlet></router-outlet>
